import { Grid, Typography } from '@cmg/design-system';
import React from 'react';
import { Link } from 'react-router-dom';

import routeFactory from '../../../../../../common/util/routeFactory';
import { DatalabScreens } from '../../../../../datalab/constants';
import type { Calendar_OfferingManagerPartsFragment } from '../../../../graphql/__generated__/Calendar_GridRowData';

export type ManagersTooltipContentProps = Readonly<{
  managers: Calendar_OfferingManagerPartsFragment[];
}>;

export const ManagersTooltipContent: React.FC<ManagersTooltipContentProps> = ({ managers }) => {
  return (
    <Grid container minWidth={200}>
      <Grid item xs={6}>
        <Typography variant="tooltip" fontWeight="bold">
          Manager
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="tooltip" fontWeight="bold">
          Role
        </Typography>
      </Grid>
      {managers.map((manager, index) => {
        const url = routeFactory.datalab.getUrlPath({
          screen: DatalabScreens.UNDERWRITER_OFFERINGS,
          type: 'table',
          query: {
            underwriter: manager.managerId,
          },
        });

        return (
          <React.Fragment key={manager.managerId ?? index}>
            <Grid item xs={6}>
              <Link to={url}>{manager.name}</Link>
            </Grid>
            <Grid item xs={6}>
              {manager.roleDisplayName}
            </Grid>
          </React.Fragment>
        );
      })}
    </Grid>
  );
};
